"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FeatureToggleContext = _interopRequireDefault(require("./FeatureToggleContext"));

var _init = _interopRequireDefault(require("./init"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Provider = _FeatureToggleContext["default"].Provider;

var FeatureToggleProvider = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(FeatureToggleProvider, _Component);

  var _super = _createSuper(FeatureToggleProvider);

  function FeatureToggleProvider(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, FeatureToggleProvider);
    _this = _super.call(this, props);
    _this.state = {
      ft: null
    };
    return _this;
  }

  (0, _createClass2["default"])(FeatureToggleProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          env = _this$props.env,
          accountId = _this$props.accountId;
      (0, _init["default"])({
        env: env,
        accountId: accountId
      }).then(function (ft) {
        if (!window.featureToggle) {
          window.featureToggle = ft;
        }

        _this2.setState({
          ft: ft
        });
      })["catch"](function (e) {
        var _window = window,
            DD_RUM = _window.DD_RUM;

        if (env === 'production' && DD_RUM) {
          DD_RUM.onReady(function () {
            DD_RUM.addAction('splitio-timeout-exp', {
              accountId: accountId
            });
          });
        }

        throw e;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var ft = this.state.ft;
      var children = this.props.children;
      return /*#__PURE__*/_react["default"].createElement(Provider, {
        value: ft
      }, children);
    }
  }]);
  return FeatureToggleProvider;
}(_react.Component);

FeatureToggleProvider.propTypes = {
  children: _propTypes["default"].node.isRequired,
  env: _propTypes["default"].string
};
var _default = FeatureToggleProvider;
exports["default"] = _default;